import { useEffect, useRef } from 'react'
import { S } from './vcStyles.js'

// ContextMenu — a small fixed-position popup used for branch and checkpoint
// action menus (mirrors PlayCanvas's dropdown menus). `items` is a list of
// { label, onClick, danger, hidden, separator }. Closes on outside click or Esc.
export default function ContextMenu({ x, y, items, onClose }) {
  const ref = useRef(null)
  useEffect(() => {
    const onDown = (e) => { if (ref.current && !ref.current.contains(e.target)) onClose() }
    const onKey = (e) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('mousedown', onDown)
    window.addEventListener('keydown', onKey)
    return () => { window.removeEventListener('mousedown', onDown); window.removeEventListener('keydown', onKey) }
  }, [onClose])

  const visible = items.filter((it) => !it.hidden)
  // keep the menu on-screen: nudge left/up if near the right/bottom edge
  const left = Math.min(x, window.innerWidth - 200)
  const top = Math.min(y, window.innerHeight - (visible.length * 30 + 16))

  return (
    <div ref={ref} style={{ ...S.menu, left, top }} role="menu">
      {visible.map((it, i) =>
        it.separator ? (
          <div key={i} style={S.menuSep} />
        ) : (
          <div
            key={i}
            style={{ ...S.menuItem, ...(it.danger ? S.menuItemDanger : {}) }}
            onMouseEnter={(e) => (e.currentTarget.style.background = '#1a2030')}
            onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
            onClick={() => { onClose(); it.onClick?.() }}
          >
            {it.label}
          </div>
        ),
      )}
    </div>
  )
}
